import { SupabaseClient } from "@supabase/supabase-js";
import { RegistryClient } from "../registryClient";
import { ConnectionManager } from "./ConnectionManager";
import { OrganizationService } from "./OrganizationService";
import { UserRegistrationService, UserRegistrationData, RegistrationResult } from "./UserRegistrationService";

export class SupabaseManager {
  private connectionManager: ConnectionManager;
  private organizationService: OrganizationService;
  private userRegistrationService: UserRegistrationService;

  constructor() {
    const registryClient = new RegistryClient();
    
    this.connectionManager = new ConnectionManager();
    this.organizationService = new OrganizationService(registryClient);
    this.userRegistrationService = new UserRegistrationService(
      this.connectionManager,
      this.organizationService
    );
  }

  getMainClient(): SupabaseClient {
    return this.connectionManager.getRegistryClient();
  }

  getCurrentClient(): SupabaseClient {
    return this.connectionManager.getCurrentClient();
  }

  getCurrentOrganizationSlug(): string | null {
    return this.connectionManager.getCurrentOrganizationSlug();
  }

  async connectToOrganizationBySlug(slug: string): Promise<SupabaseClient> {
    return this.connectionManager.connectToOrganizationBySlug(slug);
  }

  async connectToUserOrganization(email: string): Promise<SupabaseClient | null> {
    return this.connectionManager.connectToStoredOrganization(email);
  }

  disconnect(): void {
    this.connectionManager.disconnect();
  }

  async createOrganizationSchema(
    supabaseUrl: string,
    serviceKey: string
  ): Promise<boolean> {
    return this.organizationService.createOrganizationSchema(supabaseUrl, serviceKey);
  }

  async registerOrganization(
    slug: string,
    supabaseUrl: string,
    supabaseAnonKey: string
  ): Promise<boolean> {
    return this.organizationService.registerOrganization(slug, supabaseUrl, supabaseAnonKey);
  }

  async createUserAndOrganization(data: UserRegistrationData): Promise<RegistrationResult> {
    return this.userRegistrationService.registerUserAndOrganization(data);
  }
}

export const supabaseManager = new SupabaseManager();
